<template>
  <div data-scroll-container>
    <div data-scroll-section>
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-xxl-10 col-xl-12 col-lg-13 col-15">
          <h1 class="title">client area</h1>
          <p class="xxsmall font-weight-light mt-2">
            Please use credentials has been sent via email to enter
          </p>

          <form @submit.prevent="submit()" action="" method="POST" class="mt-5">
            <div class="row">
              <div class="col-md-8">
                <div class="input-wrapper label-float" :class="{
                  'has-error': $v.loginForm.email.$error || loginForm.error,
                  'has-value': $v.loginForm.email.$model,
                }">
                  <p v-cloak v-if="$v.loginForm.email.$error && !$v.loginForm.email.required
                    " class="error-msg">
                    PLEASE FILL THIS
                  </p>
                  <p v-cloak v-if="$v.loginForm.email.$error && !$v.loginForm.email.email
                    " class="error-msg">
                    FILL AN EMAIL
                  </p>

                  <label for="email">email</label>
                  <input id="email" type="text" v-model="$v.loginForm.email.$model" />
                </div>
              </div>

              <div class="col-md-8">
                <div class="input-wrapper label-float" :class="{
                  'has-error': $v.loginForm.password.$error,
                  'has-value': $v.loginForm.password.$model,
                }">
                  <p v-cloak v-if="$v.loginForm.password.$error &&
                    !$v.loginForm.password.required
                    " class="error-msg">
                    PLEASE FILL THIS
                  </p>
                  <label for="password">password</label>
                  <input-password id="password" @input="loginForm.password = $event"></input-password>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-16" v-if="loginForm.sending"></div>
            </div>

            <div class="row mt-5">
              <div class="col-16 text-right position-relative">
                <button :disabled="loginForm.response.status" type="submit" class="btn-submit" :class="[
                  loginForm.response.status,
                  { loading: loginForm.sending },
                ]">
                  <span class="background"></span>
                  <span><i class="icon-arrow-tail-right"></i></span>
                  <span class="loader"></span>
                </button>

                <p v-cloak v-if="loginForm.response.message" class="btn-response">
                  {{ loginForm.response.message }}
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
import InputPassword from "../components/input-password/index.vue";
import axios from "axios";

axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRF-TOKEN": window.Laravel.csrfToken,
};

import { email, required } from "vuelidate/lib/validators";

export default {
  components: {
    InputPassword,
  },
  data() {
    return {
      loginForm: {
        email: null,
        password: null,
        sent: false,
        sending: false,
        response: {
          status: null,
          message: null,
        },
      },
    };
  },
  validations() {
    let validations = {};

    validations = {
      loginForm: {
        email: {
          required,
          email,
        },
        password: {
          required,
        },
      },
    };

    return validations;
  },
  methods: {
    submit() {
      const component = this;

      component.$v.loginForm.$touch();

      if (component.$v.loginForm.$invalid) {
        let invalidField;

        Object.keys(component.$v.loginForm.$params).some(function (item) {
          invalidField = Object.keys(component.$v.loginForm).find(
            (key) => component.$v.loginForm[key].$invalid
          );
          return invalidField;
        });

        component.$scrollTo(document.getElementById(invalidField), 1000, {
          offset: -150,
        });
      } else {
        component.loginForm.sending = true;

        axios
          .post(window.Laravel.uris.login, component.loginForm)
          .then(function (response) {
            component.loginForm.response.status = "success";
            component.loginForm.response.message =
              "Success";

            component.$root.showLoader().then(() => {
              setTimeout(() => {
                window.location.href = "/en/client-area/galleries";
              }, 500);
            });
          })
          .catch(function (error) {
            component.loginForm.response.status = "error";
            component.loginForm.response.message = error.response.data.message
              ? error.response.data.message
              : "Something wrong happened!";

            setTimeout(() => {
              component.loginForm.response = {
                status: null,
                message: null,
              };
            }, 2000);
          })
          .finally(function () {
            component.loginForm.sending = false;
            component.loginForm.sent = true;
          });
      }
    },
    clearForm() {
      this.loginForm.sent = false;
      this.loginForm.email = null;
      this.loginForm.password = null;
      this.$v.loginForm.$reset();
    },
  },
  created() {
    this.$root.setLoaderPercentage(100);
  },
  mounted() {
    setTimeout(() => {
      this.$store.dispatch("togglePageReady", true);
    }, this.$root.loaderCountDuration - 2000);
  },
};
</script>

<style lang="scss">
@import "src/sass/variables";
@import "src/sass/mixins";
@import "node_modules/bootstrap/scss/vendor/rfs";
</style>